import yargs from "yargs";

import type { Config } from "./config";

export interface CliOptions {
	command: "run" | "list";
	opts: RunCliOptions | ListCliOptions;
}

export interface RunCliOptions extends Config {
	silent: boolean;
}

export interface ListCliOptions {
	verbose: boolean;
	json: boolean;
}

const { argv } = yargs
	.usage("Usage: $0 <command> [options]")
	.command("run <job>", "Run a job", y => {
		y.positional("job", {
			describe:
				"The job to run. It can be either the short job name or a path to a config file.",
			type: "string"
		}).option("silent", {
			alias: "s",
			type: "boolean",
			describe: "Shut your damn mouth."
		});
	})
	.command("list", "Lists available jobs in this package", y => {
		y.option("verbose", {
			alias: "v",
			type: "boolean",
			describe: "Show verbose default config."
		}).option("json", {
			alias: "j",
			type: "boolean",
			describe: "Output job list as JSON."
		});
	})
	.example(
		"$0 run place-importer",
		"Run the place-importer job with its default config"
	)
	.example(
		"$0 run ./my-config.json",
		"Run the job using the specified config file"
	)
	.example(
		"$0 run my-job --execution.parallelTaskCount 42",
		"Run my-job using the specified parallelTaskCount"
	)
	.help("h")
	.alias("h", "help")
	.demandCommand()
	.epilog("copyright 2020");

const { $0: throwaway, _: command, ...opts } = argv;

const result = ({ command: command[0], opts } as unknown) as CliOptions;
export default result;
